var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('small',{domProps:{"innerHTML":_vm._s(_vm.text)}}),(_vm.development)?_c('div',[_vm._v(_vm._s(_vm.debug))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }